import { useTranslation } from 'react-i18next';
import {
  Input,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@org/ui';

export interface GroupOption {
  groupId: string;
  label: string;
}

export interface StudentOption {
  studentId: string;
  label: string;
}

interface EventFiltersProps {
  groupId: string;
  onGroupChange: (groupId: string) => void;
  groups: GroupOption[];
  studentSearch: string;
  onStudentSearchChange: (search: string) => void;
}

export function EventFilters({
  groupId,
  onGroupChange,
  groups,
  studentSearch,
  onStudentSearchChange,
}: EventFiltersProps) {
  const { t } = useTranslation('admin');

  return (
    <div className="flex flex-wrap gap-3 rounded-xl border border-rose-50 bg-white p-4 shadow-sm">
      <div className="flex flex-col gap-1">
        <label className="text-xs uppercase tracking-[0.2em] text-gray-500">
          {t('teacher.filters.group')}
        </label>
        <Select value={groupId} onValueChange={onGroupChange}>
          <SelectTrigger className="min-w-[200px] rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm shadow-sm focus:border-[#cf2e2e] focus:outline-none">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">{t('teacher.filters.groupAll')}</SelectItem>
            {groups.map((group) => (
              <SelectItem key={group.groupId} value={group.groupId}>
                {group.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className="flex flex-col gap-1">
        <label className="text-xs uppercase tracking-[0.2em] text-gray-500">
          {t('teacher.filters.student')}
        </label>
        <Input
          type="text"
          className="min-w-[220px] rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm shadow-sm focus:border-[#cf2e2e] focus:outline-none"
          placeholder={t('teacher.filters.searchStudent')}
          value={studentSearch}
          onChange={(e) => onStudentSearchChange(e.target.value)}
        />
      </div>
    </div>
  );
}
